import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';
import { HostTabsEnum } from './host-page.component';

export const defaultHostColorHex = Colors.metalic;
const membershipCardsSpacing = 24;

export const hostPageStyles = (theme: Theme, primaryColor = defaultHostColorHex, backgroundColor = '#000000') => ({
	root: {
		display: 'flex',
		backgroundColor: '#000000',
		height: '100%',
		position: 'relative',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	background: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		height: '430px',
		backgroundColor: '#000000',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'right center',
		zIndex: 2,
		'&:after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '100%',
			background:
				'linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 45%, #9e9e9e 60%, rgba(255, 255, 255, 0.9) 80%, rgba(0, 0, 0, 0) 100%)',
		},
		'&:before': {
			content: '""',
			position: 'absolute',
			bottom: 0,
			right: 0,
			left: 0,
			zIndex: 1,
			height: '100%',
			background: 'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
		},

		[theme.breakpoints.down('md')]: {
			background: 'white',
			'&:after': {
				background: 'linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%)',
			},
		},
	},
	backgroundImage: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: '100%',
		width: '100%',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		opacity: 0.05,
	},
	backgroundColor: {
		position: 'absolute',
		top: { xs: '-100px', md: '-525px' },
		left: '50%',
		transform: 'translateX(-50%)',
		width: { xs: '120%', md: 'calc(100% - 250px)' },
		height: { xs: '550px', md: '725px' },
		borderRadius: { xs: 0, md: '20%' },
		background: `linear-gradient(-90deg, ${primaryColor} 0%, ${primaryColor}4D 100%)`,
		filter: { xs: 'blur(120px)', md: 'blur(100px)' },
	},
	header: {
		position: 'absolute',
		background: '#11141299',
		height: '46px',
		width: '100%',
		zIndex: 3,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		p: '7px 20px',
	},
	headerTitle: {
		fontFamily: 'Integral CF',
		fontSize: '17px',
		fontWeight: 600,
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	headerButton: {
		border: '1px solid #D4D4D466',
		backgroundColor: 'transparent',
		borderRadius: '50px',
		height: '32px',
		fontFamily: 'Montserrat',
		textTransform: 'unset',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '12px',
		gap: '10px',
		p: '6px 12px',
		color: '#FFFFFF',

		'& >svg': {
			width: '22px',
			height: '22px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},
	},
	content: {
		height: '100%',
		overflowY: 'auto',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',

		'&::-webkit-scrollbar': {
			width: '4px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		},
	},
	hostInfoSection: {
		display: 'flex',
		position: 'relative',
		flexDirection: { xs: 'column', md: 'row-reverse' },
		justifyContent: 'space-between',
		gap: { xs: 0, md: '20px' },
		color: 'white',
	},
	hostBackgroundImage: {
		position: 'relative',
		marginRight: { xs: 0, lg: '50px' },
		borderRadius: 0,
		width: { xs: '100%', md: '432px' },
		height: { xs: '314px', md: '540px' },
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
	},
	hostInfo: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: { xs: '14px', md: '24px' },
		px: { xs: '20px', md: 0 },
	},
	hostInfoContent: {
		display: 'flex',
		gap: '24px',
		flexDirection: { xs: 'column', md: 'row' },
		margin: '40px 0 20px',
	},
	navigation: {
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
		color: '#FFFFFF99',
		position: { xs: 'absolute', md: 'relative' },
		top: { xs: '8px', md: 0 },
		left: { xs: '20px', md: 0 },
		mt: { xs: 0, md: '22px' },
		mb: { xs: 0, md: '32px' },
	},
	navigationItem: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 400,
		lineHeight: '24px',
		cursor: 'default',
		userSelect: 'none',
	},
	navigationLink: {
		cursor: 'pointer',

		'&:hover': {
			color: '#FFFFFF',
			textDecoration: 'underline',
		},
	},
	authorAvatar: {
		width: '100px',
		minWidth: '100px',
		height: '100px',
		minHeight: '100px',
		borderRadius: '50%',
	},
	hostName: {
		fontFamily: 'Integral CF',
		fontSize: '24px',
		fontWeight: 700,
		textTransform: 'uppercase',
	},
	hostVerifiedBox: {
		position: 'relative',
		cursor: 'pointer',
		flexShrink: '0',

		'&:hover > #verify': {
			display: 'flex',
			transition: 'all 1s ease-in-out',
			alignItems: 'center',
		},
	},
	hostVerifiedTextBox: {
		display: 'none',
		position: 'absolute',
		right: { sm: -190 },
		left: { xs: -135 },
		top: { xs: 50 },
		alignItems: 'center',
		gap: '10px',
		transition: 'all 1s ease-in-out',
	},
	hostVerifiedText: {
		color: 'black',
		fontFamily: 'Nunito',
		fontWeight: 500,
		fontSize: '16px',
		lineHeight: 1.1,
		px: '16px',
		py: '12px',
		backgroundColor: 'white',
		borderRadius: '8px',
		position: 'relative',
		width: '170px',

		'&:before': {
			content: `''`,
			width: '14px',
			height: '20px',
			transform: { xs: 'rotate(90deg) translateX(-110%)' },
			clipPath: {
				xs: 'polygon(27% 32%, 63% 17%, 100% 0, 100% 100%, 61% 86%, 28% 73%, 9% 60%, 9% 45%)',
			},
			backgroundColor: 'white',
			position: 'absolute',
			left: { xs: '84%' },
			top: { xs: '0' },
		},
	},
	hostBioText: {
		fontFamily: 'Montserrat',
		fontWeight: 400,
		fontSize: '15px',
		lineHeight: '20px',
		whiteSpace: 'break-spaces',
		color: '#FFFFFF',

		'& a': {
			color: '#FFFFFF',
		},
	},
	joinChatButton: {
		borderRadius: '100px',
		backgroundColor: '#FFFFFF',
		fontFamily: 'Montserrat',
		fontWeight: '600',
		fontSize: '14px',
		lineHeight: '17px',
		color: '#000000',
		border: '1px solid #FFFFFF',
		padding: '10px 24px',
		marginBottom: '20px',
		textTransform: 'capitalize',

		'&:hover': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},
	},
	hostTab: {
		flexDirection: 'row',
		gap: '8px',
		fontFamily: 'Montserrat',
		fontSize: '18px',
		textTransform: 'none',
		color: Colors.white_a80,
		fontWeight: 500,
		padding: '10px 16px',

		'&.Mui-selected': {
			color: Colors.white,
			background: 'rgba(255, 255, 255, 0.10)',
			borderRadius: '8px 8px 0 0',
		},
	},
	placeholder: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '16px',
	},
	placeholderIcon: {
		fontFamily: 'Integral CF',
		fontSize: '56px',
		fontWeight: 600,
		lineHeight: '67px',
	},
	placeholderTitle: {
		fontFamily: 'Integral CF',
		fontSize: '24px',
		fontWeight: 600,
		lineHeight: '29px',
		color: '#FFFFFF',
		textAlign: 'center',
		mb: '10px',
	},
	placeholderDescription: {
		fontFamily: 'Montserrat',
		fontSize: '17px',
		fontWeight: 600,
		lineHeight: '21px',
		textAlign: 'center',
		color: '#FFFFFF',
	},
	upcomingEventsSection: {
		display: 'flex',
		flexDirection: 'column',
		paddingTop: { xs: '16px', md: '37px' },
		px: { xs: '16px', md: 0 },
	},
	upcomingEventsHeader: {
		display: 'flex',
		marginBottom: '22px',
		height: '36px',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	upcomingEventsTitle: {
		fontFamily: 'Integral CF',
		fontSize: '18px',
		fontWeight: 600,
		lineHeight: '22px',
		color: '#FFFFFF',
	},
	button: {
		backgroundColor: '#000000',
		border: '1px solid #FFFFFF66',
		borderRadius: '50px',
		height: '36px',
		fontFamily: 'Montserrat',
		textTransform: 'unset',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		gap: '10px',
		p: '6px 12px',
		color: '#FFFFFF',

		'& >svg': {
			width: '22px',
			height: '22px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},
	},
	secondaryButton: {
		backgroundColor: '#FFFFFF',
		border: '0.75px solid #000000',
		borderRadius: '50px',
		height: '38px',
		fontFamily: 'Integral CF',
		textTransform: 'unset',
		fontSize: '10px',
		fontWeight: 500,
		lineHeight: '13px',
		gap: '10px',
		p: '6px 12px',
		color: '#000000',

		'& >svg': {
			width: '22px',
			height: '22px',
		},

		'&:hover': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},
	},
	dayEvents: {
		padding: '0 0 40px 20px',
		borderLeft: '2px solid #FFFFFF26',
		position: 'relative',

		'&:first-of-type': {
			borderLeftStyle: 'dashed',
		},

		'&:last-of-type': {
			paddingBottom: 0,
		},
	},
	dayEventsMarker: {
		width: '8px',
		height: '8px',
		borderRadius: '50%',
		boxShadow: '0 0 0 2px #FFFFFF4D',
		position: 'absolute',
		transform: 'translate(-50%, -50%)',
		top: 0,
		left: '-1px',
	},
	dayEventsTitle: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 500,
		lineHeight: '19px',
		color: 'rgba(255, 255, 255, 0.8)',
		position: 'absolute',
		transform: 'translateY(-50%)',
		top: 0,
		left: '20px',

		'& >span': {
			fontFamily: 'Integral CF',
			color: '#FFFFFF',
			fontWeight: 600,
		},
	},
	banner: {
		height: { xs: '345px', md: '180px' },
		borderRadius: '12px',
		display: 'flex',
		flexDirection: { xs: 'column', md: 'row' },
		gap: '16px',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',

		[theme.breakpoints.down('sm')]: {
			backgroundPosition: '0 center',
		},
	},
	bannerContent: {
		flex: 1,
		display: 'flex',
		gap: '32px',
		alignItems: 'center',
		paddingRight: '190px',
		paddingLeft: '29px',

		[theme.breakpoints.down('md')]: {
			padding: '20px 30px',
		},
		[theme.breakpoints.down('sm')]: {
			flex: 'none',
		},
	},
	innerBannerContent: {
		display: 'flex',
		height: '100%',
		flexDirection: 'column',
		gap: '16px',
		justifyContent: 'center',

		[theme.breakpoints.down('sm')]: {
			height: 'auto',
		},
	},
	bannerTitle: {
		fontFamily: 'Integral CF',
		fontSize: '18px',
		fontWeight: 600,
		color: 'rgba(255, 255, 255, 0.9)',
		textAlign: { xs: 'center', md: 'left' },
	},
	bannerDescription: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 400,
		lineHeight: '18px',
		color: 'rgba(255, 255, 255, 0.9)',
		textAlign: { xs: 'center', md: 'left' },
	},
	launchOwnCommunityButton: {
		border: '1px solid rgba(255, 255, 255, 0.1)',
		fontSize: '13px',
		fontWeight: '700',
		backgroundColor: '#343434',
		borderRadius: '100px',
		color: 'white',
		padding: '10px 12px',
		maxWidth: 'fit-content',
		margin: '0 auto',
		fontFamily: 'Montserrat',

		'&:hover': {
			backgroundColor: 'white',
			color: 'black',
		},
	},
	mapBlock: {
		backgroundColor: 'rgba(16,16,16,1)',
		p: '16px',
		borderRadius: '14px',
		border: `1px solid rgba(29,29,29,1)`,
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	mapBlockLink: {
		display: 'flex',
		justifyContent: 'center',

		'& >a': {
			color: '#FFFFFFCC',
			fontFamily: 'Montserrat',
			fontSize: '13px',
			fontWeight: 500,
			lineHeight: '24px',
			outline: 0,
			textDecoration: 'underline',

			'&:hover': {
				color: '#FFFFFF',
				textDecoration: 'underline',
			},
		},
	},
	footer: {
		position: 'sticky',
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '60px',
		width: '100%',
		backgroundColor: '#000000',
		borderTop: '1px solid #FFFFFF4D',
	},
	hasNextButton: {
		border: '1px solid #FFFFFF',
		minWidth: '172px',
		padding: '10px 32px',
		borderRadius: '58px',
		minHeight: '46px',
		fontFamily: 'General Sans',
		fontSize: '14px',
		fontWeight: '600',
	},
	membershipContent: {
		pt: '42px',
		px: '16px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	membershipBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	},
	membershipCardSx: (arrLength: number) => ({
		maxWidth: {
			xs: '100%',
			sm: `calc((100% - (${membershipCardsSpacing}px * ${arrLength - 1})) / ${arrLength})`,
		},
	}),
	perksContent: {
		width: '100%',
	},
	eventListTypeButton: (requiredTab: string, currentTab: string) => ({
		p: '10px',
		width: '120px',
		height: '30px',
		fontFamily: 'Montserrat, sans-serif',
		textTransform: 'none',
		fontSize: '14px',
		fontWeight: '600',
		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		color: Colors.white_a50,
		backgroundColor: Colors.white_a5,

		'&:hover': {
			backgroundColor: Colors.white_a8,
		},

		...(requiredTab === currentTab
			? {
					color: Colors.white,
					backgroundColor: Colors.white_a10,

					'&:hover': {
						backgroundColor: Colors.white_a10,
					},
				}
			: {}),

		...(requiredTab === HostTabsEnum.EVENTS
			? {
					borderTopLeftRadius: '8px',
					borderBottomLeftRadius: '8px',
					borderTopRightRadius: '0px',
					borderBottomRightRadius: '0px',
				}
			: {}),

		...(requiredTab === HostTabsEnum.CALENDAR
			? {
					borderTopLeftRadius: '0px',
					borderBottomLeftRadius: '0px',
					borderTopRightRadius: '8px',
					borderBottomRightRadius: '8px',
				}
			: {}),
	}),
});
